/** Render API validation errors as text, including FastAPI's field-error list. */
export const apiErrorMessage = (error, fallback) => {
  const detail = error?.response?.data?.detail ?? error?.detail;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) {
    const messages = detail.map((item) => typeof item?.msg === 'string' ? item.msg : '').filter(Boolean);
    if (messages.length) return messages.join('; ');
  }
  if (typeof detail?.msg === 'string') return detail.msg;
  return fallback;
};
